module.exports = __webpack_public_path__ + "media/images/game/zs_2019/psane_slovo-4ebc969c396cf828f2737deab1d4bf42.png";